import { Typography } from '@components/Typography';
import Button from '@components/Button';
import { useTranslation } from '@hooks';
import { Footer, Header } from './styles';

const ViewGoogleEmpty = ({ onConnectAnotherAccountClick, onAddManuallyClick }) => {
    const { t } = useTranslation();

    return (
        <>
            <Header>
                <Typography variant="h6">{t('OnboardingPage.titleGoogleEmpty')}</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(0, 0, 0, 0.6)', marginTop: '4px' }}>
                    {t('OnboardingPage.subtitleGoogleEmpty')}
                </Typography>
            </Header>
            <Footer isNotMain>
                <Button type="submit" variant="outlined" onClick={onAddManuallyClick}>
                    {t('buttons.addManually')}
                </Button>
                <Typography
                    variant="caption"
                    sx={{
                        margin: '0 12px',
                        '@media (max-width: 600px)': {
                            margin: '8px 0',
                        },
                    }}
                >
                    {t('common.or')}
                </Typography>
                <Button type="submit" variant="outlined" onClick={onConnectAnotherAccountClick}>
                    {t('buttons.connectAnotherAccount')}
                </Button>
            </Footer>
        </>
    );
};

export default ViewGoogleEmpty;
